<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Informacje / ogłoszenia </h4>
              <button @click="openModal" class="btn btn-primary btn-sm"><i class="bi bi-plus-circle me-2"></i>Dodaj</button>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="custom-table">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>#</th>
                  <th>Tytuł</th>
                  <th>Informacje</th>
                  <th>Dodano</th>
                  <th>Status</th>
                  <th>Opcje</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(news, index) in newsyLocal" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ news.title }}<br>
				  <span class="badge mb-2" :class="badgeClass(news.type)">{{ typeLabel(news.type) }}</span>
				  </td>
				  <td style="font-size:20px;">
					<strong v-if="news.type == 2 || news.type == 3" class="ms-4" style="cursor:pointer" @click="showVotes(news.id)"><i class="bi bi-person-add"></i>&nbsp;{{ news.yes_count }}&nbsp;</strong>
					<strong v-if="news.type == 3" class="ms-4" style="cursor:pointer" @click="showVotes(news.id)"><i class="bi bi-person" ></i>(sam/a)&nbsp;{{ news.yes2_count }}&nbsp;</strong>
					<strong v-if="news.type == 2 || news.type == 3" class="ms-2" style="cursor:pointer" @click="showVotes(news.id)"><i class="bi bi-person-dash" ></i>&nbsp;{{ news.no_count }}&nbsp;</strong>
					<strong class="ms-2"><i class="bi bi-eye"></i>&nbsp;{{ news.total_count }}</strong>
				  </td>
                  <td>{{ formatDate(news.updated_at) }}</td>
                  <td>{{ news.active == 1 ? 'Aktywne' : 'Zarchiwizowane' }}</td>
                  <td>
                    <button @click="editNews(news)" class="btn btn-sm btn-outline-info me-2 mb-2"><i class="bi bi-pencil me-2"></i>Edytuj</button>
                    <button @click="deleteNews(news.id)" class="btn btn-sm btn-danger me-2 mb-2"><i class="bi bi-trash me-2"></i>Usuń</button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="isModalOpen" class="modal fade show" tabindex="-1" style="display: block;">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Nowa informacja</h5>
                  <button type="button" class="btn-close" @click="closeModal"></button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-label" for="title">Tytuł:</label>
                      <input id="title" v-model="newNews.title" class="form-control"/>
                    </div>
                    <div class="col-md-12">
                      <label class="form-label" for="description">Opis:</label>
						<RichTextEditorComponent
						  class="mt-2"
						  id="editorDescription"
						  label="Opis"
						  modelName="description"
						  :modelText="newNews.description"
						  :hidden="false"
						  @updateModel="e => newNews.description = e?.value ?? e"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label" for="type">Rodzaj informacji:</label>
                      <select id="type" v-model="newNews.type" class="form-select">
                        <option value="1">Informacja</option>
                        <option value="2">Ogłoszenie</option>
                        <option value="3">Komunikat</option>
                      </select>
                    </div>
                    <div class="col-md-6" v-if="newNews.type == 2 || newNews.type == 3">
                      <label class="form-label" for="mailto">Wysyłać powiadomienia o wyborze do:</label>
					<select v-model="newNews.mailto" class="select2 form-select w-100" id="mailto">
					  <option v-for="user in users" :key="user.id" :value="user.id">
						{{ user.last_name }} {{ user.first_name }}
					  </option>
					</select>                   
					</div>
                   
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" @click="closeModal">Anuluj</button>
                  <button class="btn btn-primary" @click="saveNewNews">Zapisz</button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="isEditModalOpen" class="modal fade show" tabindex="-1" style="display: block;">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Edycja informacji</h5>
                  <button type="button" class="btn-close" @click="closeEditModal"></button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-label" for="title">Nazwa typu dni wolnych:</label>
                      <input id="title" v-model="editedNews.title" class="form-control"/>
                    </div>
                    <div class="col-md-12">
					  <RichTextEditorComponent class="mt-2" id="editorDescriptionEdit" label="Opis" modelName="description" :modelText="editedNews.description" :hidden="false" @updateModel="e => editedNews.description = e?.value ?? e"/>  
					</div>
                    <div class="col-md-6">
                      <label class="form-label" for="type">Rodzaj czasu trwania:</label>
                      <select id="type" v-model="editedNews.type" class="form-select">
                        <option value="1">Informacja</option>
                        <option value="2">Ogłoszenie</option>
                        <option value="3">Komunikat</option>
                      </select>
                    </div>
                    <div class="col-md-6" v-if="editedNews.type == 2 || editedNews.type == 3">
                      <label class="form-label" for="mailto">Wysyłać powiadomienia o wyborze do:</label>
					  <select v-model="editedNews.mailto" class="select2 form-select w-100" id="mailto">
						<option v-for="user in users" :key="user.id" :value="user.id">
						  {{ user.last_name }} {{ user.first_name }}
						</option>
					  </select>                   
					</div>
                    <div class="col-md-6">
                      <label class="form-label" for="active">Status:</label>
                      <select id="active" v-model="editedNews.active" class="form-select">
                        <option value="0">Zarchiwizowana</option>
                        <option value="1">Aktywna</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" @click="closeEditModal">Anuluj</button>
                  <button class="btn btn-primary" @click="updateNews(editedNews)">Zapisz</button>
                </div>
              </div>
            </div>
          </div>

		<div v-if="isVotesModalOpen" class="modal fade show" tabindex="-1" style="display:block;">
		  <div class="modal-dialog modal-xl">
			<div class="modal-content">
			  <div class="modal-header">
				<h5 class="modal-title">
				  Lista głosów
				</h5>
				<a :href="route('kadry.newsy.votes.pdf', selectedNewsId)" target="_blank" class="btn btn-primary ms-5 me-5"><i class="bi bi-printer"></i>  Drukuj listę głosów</a>
				<a :href="route('kadry.newsy.votes.excel', selectedNewsId)" target="_blank" class="btn btn-success me-5"><i class="bi bi-file-earmark-excel"></i> Pobierz do Excel</a>
				<button type="button" class="btn-close" @click="closeVotesModal"></button>
			  </div>
			  <div class="modal-body">
				<div class="row">
				  <div :class="votesYes2 && votesYes2.length > 0 ? 'col-md-4' : 'col-md-6'">
					<div class="card border-success">
					  <div class="card-header bg-success text-white">Na TAK</div>
					  <div class="card-body p-0">
						<table class="table table-sm mb-0">
						  <tbody>
							<tr v-for="(user, index) in votesYes" :key="'yes'+user.id">
							  <td>{{ index + 1 }}</td>
							  <td>{{ user.last_name }} {{ user.first_name }}</td>
							</tr>
							<tr v-if="votesYes.length === 0">
							  <td colspan="2" class="text-center"></td>
							</tr>
						  </tbody>
						</table>
					  </div>
					</div>
				  </div>

				  <div v-if="votesYes2 && votesYes2.length > 0" class="col-md-4">
					<div class="card border-success">
					  <div class="card-header bg-success text-white">Na TAK (sam/a)</div>
					  <div class="card-body p-0">
						<table class="table table-sm mb-0">
						  <tbody>
							<tr v-for="(user, index) in votesYes2" :key="'yes2'+user.id">
							  <td>{{ index + 1 }}</td>
							  <td>{{ user.last_name }} {{ user.first_name }}</td>
							</tr>
						  </tbody>
						</table>
					  </div>
					</div>
				  </div>

				  <div :class="votesYes2 && votesYes2.length > 0 ? 'col-md-4' : 'col-md-6'">
					<div class="card border-danger">
					  <div class="card-header bg-danger text-white">Na NIE</div>
					  <div class="card-body p-0">
						<table class="table table-sm mb-0">
						  <tbody>
							<tr v-for="(user, index) in votesNo" :key="'no'+user.id">
							  <td>{{ index + 1 }}</td>
							  <td>{{ user.last_name }} {{ user.first_name }}</td>
							</tr>
							<tr v-if="votesNo.length === 0">
							  <td colspan="2" class="text-center"></td>
							</tr>
						  </tbody>
						</table>
					  </div>
					</div>
				  </div>
				</div>
			  </div>
			  <div class="modal-footer">
				<button type="button" class="btn btn-danger" @click="closeVotesModal">Zamknij</button>
			  </div>
			</div>
		  </div>
		</div>

        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import RichTextEditorComponent from "@/Pages/Kadry/parts/RichTextEditorComponent.vue";

const {hasPermission} = usePermission();

export default {
  components: {AppLayout, RichTextEditorComponent},
  props: {
    news: Array,
	users: Array,
  },
  data() {
    return {
      hasPermission,
      editingId: null,
      addingNew: false,
      newNews: this.getEmptyForm(),
      editedNews: {},
      isModalOpen: false,
      isEditModalOpen: false,
	  newsyLocal: [],
	  isVotesModalOpen: false,
	  selectedNewsId: null,
	  votesYes: [],
	  votesYes2: [],
	  votesNo: [],
     };
  },
  
  mounted() {
    this.newsyLocal = this.news.map(t => ({ ...t }));
  },
  methods: {
    
	formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return date.toISOString().split('T')[0];
    },
	
	async showVotes(newsId) {
	  this.selectedNewsId = newsId;

	  try {
		const response = await axios.get(
		  route('kadry.newsy.votes', newsId)
		);

		this.votesYes = response.data.yes;
		this.votesYes2 = response.data.yes2;
		this.votesNo = response.data.no;
		this.isVotesModalOpen = true;
	  } catch (e) {
		console.error(e);
	  }
	},
	
	closeVotesModal() {
	  this.isVotesModalOpen = false;
	  this.selectedNewsId = null;
	  this.votesYes = [];
	  this.votesYes2 = [];
	  this.votesNo = [];
	},	
	
  	initUserSelect() {
	  this.$nextTick(() => {
		if ($('#mailto').hasClass("select2-hidden-accessible")) {
		  $('#mailto').select2('destroy');
		}

		$('#mailto')
		  .select2({
			dropdownParent: $('.modal')
		  })
		  .val(this.form.user_id || '')  // ustawienie domyślnej wartości
		  .trigger('change')
		  .on('select2:select', (e) => {
			const selectedUserId = parseInt(e.params.data.id);
			this.form.user_id = selectedUserId;
		  });
	  });
	},
	
    async openModal() {
      this.isModalOpen = true;
    },

    closeModal() {
      this.isModalOpen = false;
      this.newNews = this.getEmptyForm();
    },

    closeEditModal() {
      this.isEditModalOpen = false;
    },
    SelectNaTekst(select) {
      switch (select) {
        case 0:
          return 'Dni';
        case 1:
          return 'Tygodni';
        case 2:
          return 'Miesięcy';
        default:
          return '';
      }
    },

    getEmptyForm() {
      return {
        id: null,
        title: '',
        description: '<pre><span style="font-size: 10pt; font-family: arimo, helvetica, sans-serif;">Wstaw tu treść informacji</span></pre>',
        type: 1,
        mailto: '',
        active: null,
      };
    },

    addNews() {
      this.addingNew = true;
      this.newNews = this.getEmptyForm();
    },
    cancelNewNews() {
      this.addingNew = false;
      this.newNews = this.getEmptyForm();
    },
    editNews(news) {
      this.editingId = news.id;
      this.isEditModalOpen = true;
      this.editedNews = { ...news };

    },

updateNews(news) {

console.log('id', news.id);
console.log('news', news);
  const payload = {
    ...news,
    description: typeof news.description === 'object'
      ? news.description.value
      : news.description
  };

  this.$inertia.put(route('kadry.newsy.update', news.id), payload, {
    onSuccess: () => {
      const idx = this.newsyLocal.findIndex(w => w.id === news.id);
      if (idx !== -1) this.newsyLocal[idx] = { ...payload };

      this.isEditModalOpen = false;
    }
  });
},

saveNewNews() {
  this.$inertia.post(route('kadry.newsy.dodaj'), this.newNews, {
    onSuccess: () => {
      this.newNews = this.getEmptyForm();
      this.isModalOpen = false;
	  this.newsyLocal = this.news.map(t => ({ ...t }));
    }
  });
},
    deleteNews(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie informacji',
        html: 'Czy na pewno chcesz usunąć wybraną informację?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then((result) => {
        if (result.isConfirmed) {
			this.$inertia.delete(route('kadry.newsy.usun', id), {
			  onSuccess: () => {
				this.newsyLocal = this.newsyLocal.filter(w => w.id !== id);
			  }
			});
        }
      });
    },
	    typeLabel(type) {
      return {
        1: 'Informacja',
        2: 'Ogłoszenie',
        3: 'Komunikat'
      }[type] || 'Komunikat'
    },

    badgeClass(type) {
      return {
        1: 'bg-primary',
        2: 'bg-info',
        3: 'bg-success'
      }[type] || 'bg-secondary'
    }
	
  }
};
</script>
